import { DashboardOutlined } from "@ant-design/icons";
import React, { lazy } from "react";
export const staticPathUnAuthen = {
};

const routeUnAuthens = [
   
];

function flatRouteConfig(routes) {
    let flatRoutes = [];
    Array.isArray(routes) &&
        routes.forEach((item) => {
            if (item.childrens) {
                flatRoutes.push(...item.childrens);
            } else {
                item.path && flatRoutes.push(item);
            }
        });
    return flatRoutes;
}

export const flatUnAuthenConfig = flatRouteConfig(routeUnAuthens);

export default routeUnAuthens;
